import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isStudioOpen, setIsStudioOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const isStudioRentalActive = () =>
    [
      "/recording-studio",
      "/podcast-studio",
      "/multipurpose-studio",
      "/equipment-rental",
    ].includes(location.pathname);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const toggleStudioMenu = () => {
    setIsStudioOpen((prev) => !prev);
  };

  // Sticky header
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 415);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Route change par reset
  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
    setIsStudioOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* ================= MOBILE MENU ================= */}
      <div
        className={`th-menu-wrapper ${
          isMobileMenuOpen ? "th-body-visible" : ""
        }`}
      >
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={toggleMobileMenu}>
            <i className="fal fa-times" />
          </button>

          <div className="mobile-logo">
            <Link to="/">
              <img src="/assest/img/logo.png" alt="Vega Studio" />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li>
                <Link
                  to="/"
                  onClick={toggleMobileMenu}
                  className={`menu-highlight no-underline ${
                    isActive("/") ? "active" : ""
                  }`}
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  onClick={toggleMobileMenu}
                  className={`no-underline ${
                    isActive("/about") ? "active" : ""
                  }`}
                >
                  About
                </Link>
              </li>

              {/* ===== MOBILE SUBMENU ===== */}
              <li
                className={`menu-item-has-children ${
                  isStudioOpen ? "submenu-open" : ""
                }`}
              >
                <span
                  className="no-underline d-flex j "
                  onClick={toggleStudioMenu}
                  style={{ cursor: "pointer" }}
                >
                  <span className='icon-box-costum'></span>
                  Studio Rental
                </span>

                <ul className="sub-menu">
                  <li>
                    <Link
                      to="/recording-studio"
                      onClick={toggleMobileMenu}
                      className={isActive("/recording-studio") ? "active" : ""}
                    >
                      Recording Studio
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/podcast-studio"
                      onClick={toggleMobileMenu}
                      className={isActive("/podcast-studio") ? "active" : ""}
                    >
                      Podcast Studio
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/multipurpose-studio"
                      onClick={toggleMobileMenu}
                      className={isActive("/multipurpose-studio") ? "active" : ""}
                    >
                      Multipurpose Studio
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link
                  to="/dan"
                  onClick={toggleMobileMenu}
                  className={`no-underline ${
                    isActive("/dan") ? "active" : ""
                  }`}
                >
                  Dance Studio
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  onClick={toggleMobileMenu}
                  className={`no-underline ${
                    isActive("/contact") ? "active" : ""
                  }`}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ================= HEADER ================= */}
      <header
        className={`th-header header-layout5 header-layout11 ${
          isSticky ? "is-sticky" : ""
        }`}
      >
        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/assest/img/logo.png" alt="Vega Studio" />
                    </Link>
                  </div>
                </div>

                {/* DESKTOP MENU */}
                <div className="col-auto">
                  <nav className="main-menu d-none d-lg-inline-block">
                    <ul>
                      <li>
                        <Link
                          to="/"
                          className={isActive("/") ? "active" : ""}
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/about"
                          className={isActive("/about") ? "active" : ""}
                        >
                          About
                        </Link>
                      </li>
                      <li
                        className={`menu-item-has-children ${
                          isStudioRentalActive() ? "active" : ""
                        }`}
                      >
                        <span className="menu-costum">Studio Rental
                            &nbsp;<i className={`fas fa-chevron-down`}/>
                        </span>
                        <ul className="sub-menu">
                          <li>
                            <Link to="/recording-studio">
                              Recording Studio
                            </Link>
                          </li>
                          <li>
                            <Link to="/podcast-studio">Podcast Studio</Link>
                          </li>
                          <li>
                            <Link to="/multipurpose-studio">
                              Multipurpose Studio
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link
                          to="/dan"
                          className={isActive("/dan") ? "active" : ""}
                        >
                          Dance Studio
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/contact"
                          className={isActive("/contact") ? "active" : ""}
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>

                {/* RIGHT BUTTON */}
                <div className="col-auto">
                  <div className="header-button">
                    <button
                      className="th-menu-toggle d-inline-block d-lg-none"
                      onClick={toggleMobileMenu}
                    >
                      <i className="far fa-bars" />
                    </button>
                    <Link to="/book" className="th-btn red-btn">
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
